import { use, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setModalState, setStep } from "../redux/communityStepSlice";
import { useSelector, useDispatch } from "react-redux";
import * as APIS from "../utils/service";

const LeftNav = ({ SmallWidth = true, favList=[] }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const type = searchParams.get("type");
    const gathering = searchParams.get("group");
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [leftNavNum, setLeftNavNum] = useState(1); // ??

    const { step, modalState } = useSelector((s) => s.communityStepReducer);

    //신규추가
    // const [favList, setFavList] = useState(listData)


    const handleStepChange = (newStep) => {
        dispatch(setStep(newStep));
    };
    const handleModalState = (state) => {
        dispatch(setModalState(state));
    };
    // location.pathname 값을 판단해서 왼쪽 네비게이션 css를 active 시키는 코드
    useEffect(() => {
        //자유 커뮤니티 일때
        if (
            location.pathname.includes("FreeCommunity") ||
            location.pathname.includes("FreeCommunityWrite") ||
            location.pathname.includes("FreeCommunityContent")
        ) {
            setLeftNavNum(7);
            return;
        }
    }, [location]);

    // const loadFav = () => {
    //     APIS.postData('/v1/communityGroup/myFav', {})
    //         .then(({ data }) => {
    //             setFavList(data)
    //         }).catch(({ response }) => {
    //             setFavList([])
    //         })
    // }

    useEffect(() => {
        // loadFav()
    }, [])

    return (
        <div className="left_nav_wrap">
            <div className="left_nav">
                <div className="left_nav_title">
                    <p>커뮤니티</p>
                </div>
                <div className="left_nav_content_wrap">
                    <div className="left_nav_content">
                        <div
                            className={`inner_content ${leftNavNum === 7 ? "active" : ""}`}
                            onClick={() => {
                                navigate(`/FreeCommunity`);
                            }}
                        >
                            <p>자유로운 이야기</p>
                            <img
                                src={`./images/icons/arrow_purple_right.svg`}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* 소모임 */}
            <div className="left_nav">
                <div className="left_nav_title">
                    <p>소모임</p>
                </div>
                <div className="left_nav_content_wrap">
                    <div className="left_nav_content">
                        {favList?.map(v => {
                            return <div
                                className={`inner_content ${parseInt(gathering) === v?.idx ? "active" : ""}`}
                                onClick={() => {
                                    navigate(`/GatheringBoard?group=${v?.idx}`);
                                }}
                            >
                                <p>{v?.title}</p>
                                <img
                                    src={`./images/icons/arrow_purple_right.svg`}
                                />
                            </div>
                        })}

                    </div>
                    <div className="lineWidth"></div>
                </div>
                <div className="left_nav_button">
                    <button
                        onClick={() => {
                            handleModalState(!modalState);
                            handleStepChange(1);
                        }}
                    >
                        소모임 검색/관리
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LeftNav;
